module.exports = __webpack_public_path__ + "img/menu-open.4b1569bc.svg";